import notForbidden from '@/assets/images/403.png';
import { useTitle } from '@/hooks';
import type { FC } from 'react';

export const Forbidden: FC = () => {
  // title
  useTitle('403');

  return (
    <main className="flex flex-col justify-center items-center h-full bg-white">
      <img src={notForbidden} width={280} alt="403" />
      <p className="text-sm text-secondary-2">无权访问</p>
    </main>
  );
};
